import { Button } from "@/components/field";
import { useSeed } from "@/features/plausibility/use-seed";

/**
 * One-off seeding of the plausibility tables from the in-code seeds. Preview
 * first: a dry run counts what would be written and shows the current table
 * versions without touching anything. A real run is idempotent, so repeating
 * it is safe, but it bumps every version counter it touches.
 */
export const SeedPanel = () => {
	const seed = useSeed();
	const report = seed.data;

	return (
		<section className="border-secondary rounded-md border p-4">
			<h3 className="text-primary text-sm font-semibold">Seed tables</h3>
			<p className="text-secondary text-sm">
				Write the in-code taxonomy, global priors, and discriminator specs into
				the admin database. Idempotent; a real run bumps the table versions. A
				global prior you have edited is left alone: delete the row and seed
				again to restore the seed value.
			</p>
			<div className="mt-3 flex flex-wrap items-center gap-2">
				<Button
					disabled={seed.isPending}
					onClick={() => seed.mutate({ dryRun: true })}
					type="button"
					variant="secondary"
				>
					Preview (dry run)
				</Button>
				<Button
					disabled={seed.isPending}
					onClick={() => seed.mutate({ dryRun: false })}
					type="button"
				>
					{seed.isPending ? "Seeding…" : "Seed tables"}
				</Button>
			</div>
			{report && (
				<p className="text-secondary mt-2 text-sm" role="status">
					{report.dryRun ? "Would write" : "Wrote"} {report.taxonomy} taxonomy
					classes, {report.priors} global priors
					{report.priorsSkipped > 0 &&
						` (${report.priorsSkipped} edited by staff and left alone)`}
					, {report.discriminators} discriminator specs. Versions: taxonomy{" "}
					{report.versions.taxonomy}, priors {report.versions.priors},
					discriminators {report.versions.discriminators}, lr{" "}
					{report.versions.lr}.
				</p>
			)}
			{seed.error && (
				<p className="text-error-primary mt-2 text-sm" role="alert">
					{seed.error.message}
				</p>
			)}
		</section>
	);
};
